import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    topNavState: 'home',
    leftNavState: 'home',
    isLogin: 0,
    userInfo: {},
    pageName: ''
  },
  mutations: {
    changeLogin (state, data) {
      state.isLogin = data
    },
    setPageName (state, data) {
      state.pageName = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/Store.js